import React from "react";
import Bannerimg from '../../src/asset/images/banner-img.png';
import About from '../../src/asset/images/about-img.png'
import Appstore from '../../src/asset/images/app-store.png'
import Googleplay from '../../src/asset/images/google-play.png'
import Userprofile from '../../src/asset/images/user-profile-img.png'
import Story from '../../src/asset/images/story-img.png'
import Rating1 from '../../src/asset/images/rating1.png'
import Rating2 from '../../src/asset/images/rating2.png'
import Cover from '../../src/asset/images/cover.png'
import Icon1 from '../../src/asset/images/icon1.svg'
import Icon2 from '../../src/asset/images/icon2.svg'
import Gif from '../../src/asset/images/Shadowz-about.gif'
import Slider from 'react-slick'
import { Link } from "react-router-dom";
const Home = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        speed: 5000,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* section 1 */}
            <section className="section-1">
                <div className="container pt-5">
                    <div className="section-1-content text-center py-5">
                        <h1>Let’s Connect Simply with the <br /> People And Send & Receive Coins!</h1>
                        <p className="py-3">Welcome to our social app landing page, the ultimate platform to connect with like-minded people <br /> around the world! Our app is designed to bring people together, foster relationships, and help you <br /> discover new communities that share your interests.</p>
                        {/* <button className="btn"><img src={Download} alt="img" className="img-fluid" /></button> */}
                        <a href="#download">
                            <button className="btn btn-light px-4 py-3 "><span className="d-flex align-items-center gap-3">Download Shadowz <img src={Icon1} alt="img" /><img src={Icon2} alt="img" /></span></button>
                        </a>
                    </div>
                </div>

            </section>

            {/* section-2 */}
            <section className="section-2">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-6">
                            <div className="banner-img text-center">
                                <img src={Bannerimg} alt="img" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* about section */}
            <section className="about-section py-5" id="about">
                <div className="container">
                    <div className="row gy-5 align-items-center">
                        <div className="col-md-6">
                            <div className="text-center text-md-start about-img position-relative">
                                <img src={About} alt="img" className="img-fluid" />
                                {/* <div className="about-gif">
                                    <img src={Gif} alt="img" className="img-fluid" />
                                </div> */}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="about-text text-center text-md-start">
                                <h2 className="pb-3">About App.</h2>
                                {/* <p>Welcome to our revolutionary social networking app that will change the way you connect with others online. We offer a dynamic platform that prioritizes community building and encourages users to express their unique personalities. Our app features a customizable personal profile tool that allows you to showcase your individuality and present your true self to the world. Share your interests, hobbies, and unique personality with the wider community.</p>
                                <p>
                                    Our app offers a multitude of features designed to foster meaningful connections. Engage in thoughtful conversations with other users who share your interests using our group discussion feature, and connect instantly with potential friends or collaborators with our real-time chat functionality. Stay up-to-date on the latest developments in your network with our news feed, and expand your horizons by discovering new communities to explore with our powerful search tools.
                                </p>
                                <p>
                                    In addition to these features, our app offers seamless photo and video sharing, enabling you to share your cherished moments and experiences with your network. Our sleek, intuitive interface makes navigating our app a breeze, and our user-friendly design ensures that you can focus on building meaningful connections.
                                </p> */}

                                <p>Our social networking app offers a revolutionary platform that emphasizes community building and encourages users to showcase their unique personalities. Enjoy a customizable personal profile tool, group discussion and real-time chat functionalities for engaging conversations, and stay up-to-date with our news feed and powerful search tools. Our seamless photo and video sharing features, intuitive interface, and user-friendly design make it easy for you to connect and build meaningful relationships.
                                </p>
                                <span>App’s available on:</span>
                                <div className="d-flex flex-wrap flex-md-nowrap justify-content-center justify-content-md-start mt-2">
                                    {/* <a href={`https://www.apple.com/app-store`}> */}
                                    <a href='https://apps.apple.com/in/app/shadowz/id6747656833' target="_blank">

                                        <button className="btn ps-0"><img src={Appstore} alt="img" /></button>
                                    </a>
                                    {/* </a> */}
                                    {/* <a href={`https://play.google.com/store/apps`}>   */}
                                    <Link to='https://play.google.com/store/apps/details?id=com.hf.shadowz&hl=en_IN' target="_blank">
                                        <button className="btn ps-0"><img src={Googleplay} alt="img" /></button></Link>
                                    {/* </a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* user profile section */}
            <section className="user-profile-section py-5" id="features">
                <div className="container ">
                    <div className="row gy-5 align-items-center justify-content-center ">
                        <div className="col-md-6 order-2 order-md-1">
                            <div className="user-profile-text text-center text-md-start">
                                <h5>Features</h5>
                                <h2>User Profile.</h2>
                                <p className="">Creating a personal profile is an essential part of our website's community-building experience. Your profile provides a window into your personality, interests, and hobbies, offering other users the opportunity to get to know you on a deeper level. By presenting your authentic self through your profile, you can attract like-minded people who share your passions and values.
                                </p>
                            </div>
                        </div>
                        <div className="col-6 order-1 order-md-2">
                            <div className="user-profile-image">
                                <img src={Userprofile} alt="img" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* story section */}
            <section className="story-section py-5">
                <div className="container">
                    <div className="row align-items-center justify-content-center gy-5">
                        <div className="col-7 col-md-5">
                            <div className="story-img">
                                <img src={Story} alt="img" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="story-text text-center text-md-start">
                                <h2 className="pb-2">The Story of SHADOWZ Begins with Trust.</h2>
                                <p>Our social app was built to address the need for a platform that values personal expression, diversity, and authentic connections. Our founders recognized the importance of creating a space that prioritizes community building and fosters meaningful connections based on shared interests and values. Today, our app is a dynamic platform that attracts individuals from all walks of life who seek to make genuine connections and showcase their authentic selves. Our dynamic platform provides a user-friendly interface that makes it easy for you to effortlessly make new friends, discover exciting communities and explore new interests. <br />
                                    Join our platform today, create your personal profile, and start exploring a new world of community-building and personal expression!

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* review section */}
            <section className="review-section py-5" id="download">
                <div className="container">
                    <div className="py-5">
                        <h2 className="review">Download App Now</h2>
                    </div>
                    <div className="row gy-5 justify-content-between">
                        <div className="col-md-6 col-lg-5 ">
                            <div className="download-card text-center text-md-start p-5">

                                <div className="d-flex align-items-end justify-content-center justify-content-md-start  gap-3 rating">
                                    <h3 className="m-0">5.0</h3>

                                    <img src={Rating1} alt="img" className="img-fluid" />
                                </div>
                                <h4 className="py-4">App Store</h4>
                                {/* <a href={`https://www.apple.com/app-store`}> */}
                                <a href='https://apps.apple.com/in/app/shadowz/id6747656833' target="_blank">

                                    <button className="btn btn-light w-100"><span className="d-flex align-items-center gap-3 justify-content-center"><img src={Icon1} alt="img" className="img-fluid" />Download the App</span></button>
                                </a>
                                {/* </a> */}
                            </div>

                        </div>
                        <div className="col-md-6 col-lg-5 ">
                            <div className="download-card text-center text-md-start p-5">
                                <div className="d-flex align-items-end justify-content-center justify-content-md-start gap-3 rating">
                                    <h3 className="m-0">4.5</h3>

                                    <img src={Rating2} alt="img" className="img-fluid" />
                                </div>
                                <h4 className="py-4">Play Store</h4>
                                {/* <a href={`https://play.google.com/store/apps`}> */}
                                <Link to='https://play.google.com/store/apps/details?id=com.hf.shadowz&hl=en_IN' target="_blank">

                                    <button className="btn btn-light w-100"><span className="d-flex align-items-center gap-3 justify-content-center"><img src={Icon2} alt="img" className="img-fluid" />Download the App</span></button></Link>
                                {/* </a> */}
                            </div>
                        </div>

                    </div>

                </div>
            </section>

            {/* cover- section */}
            <section className="cover-section">
                <img src={Cover} alt="img" className="img-fluid" />
            </section>

        </>
    )
}
export default Home;